import React, {Component, Fragment} from 'react';
import {RouteComponentProps} from 'react-router';
import BookingLayout from 'layouts/Booking';
import {logPageView} from 'services/analytics';
import {DraftBooking} from 'services/entities/booking';
import RouteURLs from 'RouteURLs';
import BookingBanner from '../components/BookingBanner';
import {BookingStep} from '../steps';
import './index.scss';
import {
  loadDraftBooking,
  saveDraftBooking,
  setDraftBookingProductOption,
  setDraftBookingProductQuantity
} from 'services/bookings/drafts';
import BookingFooter from '../components/BookingFooter';
import {loadSpaceProducts} from 'services/products';
import {Product, ProductCategory} from 'services/entities/products';
import {handleError} from 'util/errors';
import StaffCategory from './StaffCategory';
import FurnitureCategory from './FurnitureCategory';
import StorageCategory from './StorageCategory';
import Note from '../components/Note';

interface EditBookingAddOnsPageProps extends RouteComponentProps<{code?: string}> {
}

interface EditBookingAddOnsPageState {
  booking: DraftBooking|null;
  products: Product[]|null;
  expandedCategories: ProductCategory[];
}

export default class EditBookingAddOnsPage extends Component<EditBookingAddOnsPageProps, EditBookingAddOnsPageState> {
  state: EditBookingAddOnsPageState = {
    booking: null,
    products: null,
    expandedCategories: []
  };

  componentDidMount(): void {
    logPageView(this.props.location.pathname, 'Create Booking - Add-ons');
    loadDraftBooking(this.props.match.params.code).then(
      booking => {
        if(booking) {
          this.setState({'booking': booking});
          loadSpaceProducts(booking.space!).then(
            products => this.setState({products: products}),
            err => handleError('Unable to load products', err)
          );
        } else {
          this.props.history.replace(RouteURLs.CREATE_BOOKING_TIME);
        }
      },
      () => this.props.history.replace(RouteURLs.CREATE_BOOKING_TIME)
    );
  }

  onProductQuantityChanged = (productSKU: string, quantity: number) => {
    const booking: DraftBooking|null = this.state.booking;
    if(!booking) {
      console.warn("Booking not loaded");
      return;
    }
    setDraftBookingProductQuantity(booking, productSKU, quantity);
    saveDraftBooking(booking);
    this.setState({booking: booking});
  };

  onProductOptionValueChanged = (productSKU: string, option: string, value: string|null) => {
    const booking: DraftBooking|null = this.state.booking;
    if(!booking) {
      console.warn("Booking not loaded");
      return;
    }
    setDraftBookingProductOption(booking, productSKU, option, value);
    saveDraftBooking(booking);
    this.setState({booking: booking});
  };

  getProductsByCategory(category: ProductCategory): Product[] {
    const products: Product[]|null = this.state.products;
    if(!products) {
      return [];
    }
    return products!.filter(p => p.category === category);
  }

  render() {
    const booking: DraftBooking|null = this.state.booking;
    return <BookingLayout id="create-booking-add-ons-page" footerChildren={<BookingFooter booking={booking} currentStep={BookingStep.AddOns} />}>
      <BookingBanner title='Add-ons' subtitle='Select additional options' currentStep={BookingStep.AddOns} booking={booking}/>
      { booking && !booking!.code && <Note>You may make changes to your booking up-to 7 days prior to a booking’s date.</Note> }
      { this.state.products && <Fragment>
        <StaffCategory booking={booking} products={this.getProductsByCategory(ProductCategory.Staff)}
                       onProductQuantityChanged={this.onProductQuantityChanged}
                       onProductOptionValueChanged={this.onProductOptionValueChanged}/>
        <FurnitureCategory booking={booking} products={this.getProductsByCategory(ProductCategory.Furniture)}
                       onProductQuantityChanged={this.onProductQuantityChanged}
                       onProductOptionValueChanged={this.onProductOptionValueChanged} />
        <StorageCategory booking={booking} products={this.getProductsByCategory(ProductCategory.Storage)}
                       onProductQuantityChanged={this.onProductQuantityChanged}
                       onProductOptionValueChanged={this.onProductOptionValueChanged}/>
      </Fragment> }
    </BookingLayout>;
  }
}